import {find} from 'lodash'

export default function isLicenseExpired(role, assessmentSetId, userLicenses) {
    
    if (role === "Student") {
        let val = find(userLicenses, function (val) {
          return val.licenseSet === assessmentSetId
        })
        if (val && (Number(val.endDate) < Date.now())) {
          return true;
        }
      }
      return false;

}




// WEBPACK FOOTER //
// ./src/helpers/users/licenses/isLicenseExpired.js